import assign from '../_helpers/assign.js';
var sameOwner = function sameOwner(a, b) {
  return a === b || !!a && !!b && a.object === b.object && a.path === b.path;
};
// addListener gives every entry its owners
export var ownersOf = function ownersOf(event) {
  return event.info.owners;
};
export function hasOwner(event, owner) {
  return ownersOf(event).some(function (existing) {
    return sameOwner(existing, owner);
  });
}
export function addOwner(event, owner) {
  if (!hasOwner(event, owner)) {
    event.info = assign({}, event.info, {
      owners: ownersOf(event).concat([owner])
    });
  }
}
// drops the owner; true when nobody keeps the listener any more
export function dropOwner(event, owner) {
  var rest = ownersOf(event).filter(function (existing) {
    return !sameOwner(existing, owner);
  });
  event.info = assign({}, event.info, {
    owners: rest
  });
  return !rest.length;
}